import { render, staticRenderFns } from "./UATProjectConfigMgmtView.vue?vue&type=template&id=ae15efbc&scoped=true&"
import script from "./UATProjectConfigMgmtView.vue?vue&type=script&lang=js&"
export * from "./UATProjectConfigMgmtView.vue?vue&type=script&lang=js&"
import style0 from "./UATProjectConfigMgmtView.vue?vue&type=style&index=0&id=ae15efbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae15efbc",
  null
  
)

export default component.exports